import * as Yup from "yup";
import { Box, Button } from "@mui/material";
import PkCommonArrow from "../../../components/common/PkCommonArrow";
import PkCommonInfo from "../../../components/common/PkCommonInfo";
import PkCommonResponse from "../../../components/common/PkCommonResponse";
import { getLayoutText } from "../../../components/layout/getLayoutText";
import { getLayoutLead } from "../../../components/layout/getLayoutLead";
import { getLayoutView } from "../../../components/layout/getLayoutView";
import { postStyle, postSubmit } from "../../../fetch/postSubmit";
import React from "react";

function Application() {
  const [viewer, viewerSet] = React.useState(<></>);
  const [status, statusSet] = React.useState({
    letter: "newsletter",
    usage: "edu",
    hours: "pt",
    level: "noexp",
    budget: "md",
    submit: false,
  });
  const __groupVx = (i0, i1) => (
    <Box sx={{ display: `flex`, flexDirection: { xs: `column`, sm: `row` } }}>
      <Box sx={{ pr: { xs: 0, sm: 0.75 }, width: { xs: `100%`, sm: `50%` } }}>
        <Box sx={postStyle()}>{i0}</Box>
      </Box>
      <Box sx={{ pl: { xs: 0, sm: 0.75 }, width: { xs: `100%`, sm: `50%` } }}>
        <Box sx={postStyle()}>{i1}</Box>
      </Box>
    </Box>
  );
  return (
    <Box
      sx={{
        borderRadius: "8px",
        maxWidth: "600px",
        margin: "auto",
        py: 14,
        px: 4,
      }}
    >
      {((
        _yup = {
          url: (v) => Yup.string().url().required("Required").validateSync(v),
          tag: (v) => Yup.string().min(2).required("Required").validateSync(v),
        },
      ) => (
        <>
          {__groupVx(
            <PkCommonInfo
              disabled={status.submit}
              validate={_yup.tag}
              update={(v) => statusSet({ ...status, fname: v, submit: false })}
              format={(v) => v}
              value=""
              label="FIRST NAME"
              name="firstName"
              variant="standard"
              required
            />,
            <PkCommonInfo
              disabled={status.submit}
              validate={_yup.tag}
              update={(v) => statusSet({ ...status, lname: v, submit: false })}
              format={(v) => v}
              value=""
              label="LAST NAME"
              name="lastName"
              variant="standard"
              required
            />,
          )}
          <Box sx={postStyle()}>
            <PkCommonInfo
              disabled={status.submit}
              validate={(v) =>
                Yup.string().email().required("Required").validateSync(v)
              }
              update={(v) => statusSet({ ...status, email: v, submit: false })}
              format={(v) => v}
              value=""
              label="EMAIL ADDRESS"
              name="email"
              variant="standard"
              required
            />
          </Box>
          <Box sx={postStyle()}>
            <PkCommonInfo
              disabled={status.submit}
              validate={_yup.url}
              update={(v) => statusSet({ ...status, media: v, submit: false })}
              format={(v) => v}
              value=""
              label="SOCIAL MEDIA"
              name="media"
              variant="standard"
              placeholder="http://"
              required
            />
          </Box>
          <Box sx={postStyle()}>
            <PkCommonInfo
              disabled={status.submit}
              validate={_yup.tag}
              update={(v) => statusSet({ ...status, range: v, submit: false })}
              format={(v) => v}
              value=""
              label="OCCUPATION"
              name="occupation"
              variant="standard"
              required
            />
          </Box>
          <Box sx={postStyle()}>
            <PkCommonInfo
              disabled={status.submit}
              validate={(v) => true}
              update={(v) =>
                statusSet({
                  ...status,
                  usage: v === `0` ? `edu` : `com`,
                  submit: false,
                })
              }
              format={(v) => v}
              value="0"
              label="Usage Intention"
              name="intention"
              variant="standard"
              select={true}
              options={[
                { label: "Educational, I am trying things out", value: "0" },
                { label: "Commercial, I plan on making money", value: "1" },
              ]}
            />
          </Box>
          <Box sx={postStyle()}>
            <PkCommonInfo
              disabled={status.submit}
              validate={(v) => true}
              update={(v) =>
                statusSet({
                  ...status,
                  hours: v === `0` ? `st` : v === `1` ? `pt` : `ft`,
                  submit: false,
                })
              }
              format={(v) => v}
              value="0"
              label="Time Commitment, if selected by program"
              name="commitment"
              variant="standard"
              select={true}
              options={[
                { label: "Spare-time, less than 10 hrs", value: "0" },
                { label: "Part-time, less than 15 hrs", value: "1" },
                { label: "Full-time, less than 35 hrs", value: "2" },
              ]}
            />
          </Box>
          <Box sx={postStyle()}>
            <PkCommonInfo
              disabled={status.submit}
              validate={(v) => true}
              update={(v) =>
                statusSet({
                  ...status,
                  level: v === `0` ? `noexp` : `exp`,
                  submit: false,
                })
              }
              format={(v) => v}
              value="0"
              label="Experience Level"
              name="experience"
              variant="standard"
              select={true}
              options={[
                { label: "No Experience, I am new to this", value: "0" },
                {
                  label: "Experienced, I've created a game before",
                  value: "1",
                },
              ]}
            />
          </Box>
          <Box sx={postStyle()}>
            <PkCommonInfo
              disabled={status.submit}
              validate={(v) => true}
              update={(v) =>
                statusSet({
                  ...status,
                  letter: v === `0` ? `newsletter` : `no_newsletter`,
                  submit: false,
                })
              }
              format={(v) => v}
              value="0"
              label="Keep Up With Polycaik"
              name="newsletter"
              variant="standard"
              select={true}
              options={[
                {
                  label: "I consent to join the Polycaik newsletter",
                  value: "0",
                },
                {
                  label: "I do not consent to join the Polycaik newsletter",
                  value: "1",
                },
              ]}
            />
          </Box>
          <Box sx={postStyle()}>
            <PkCommonInfo
              disabled={status.submit}
              validate={_yup.tag}
              update={(v) => statusSet({ ...status, reason: v, submit: false })}
              format={(v) => v}
              value=""
              label="Tell us why you love video games."
              name="brief"
              variant="standard"
              multiline={true}
              required
            />
          </Box>
          <Button
            disabled={status.submit}
            fullWidth
            variant="contained"
            sx={{
              mt: 1.25,
              "&.Mui-disabled": (theme) => ({
                ...{
                  color: theme.palette.grey[400],
                  backgroundColor: theme.palette.grey[300],
                },
              }),
            }}
            onClick={() => {
              statusSet({ ...status, submit: true });
              postSubmit(
                {
                  type: "DEVELOPER",
                  ...(({ submit, ...r }) => r)(status),
                },
                (status) => {
                  if (status !== 200) {
                    statusSet({ ...status, submit: false });
                    viewerSet(
                      <PkCommonResponse
                        type="error"
                        response="Please fill in all required fields. If the error persists, refresh the page or reach out to request@polycaik.com."
                      />,
                    );
                    return;
                  }
                  viewerSet(
                    <PkCommonResponse response="Thank you for applying to join the cohort! We have received your application and will be in touch with you shortly." />,
                  );
                },
              );
            }}
          >
            APPLY NOW
          </Button>
        </>
      ))()}
      {viewer}
    </Box>
  );
}
export function Apply() {
  return (
    <Box sx={{ backgroundColor: "white" }}>
      {getLayoutLead(
        <>
          Join the waitlist for early access to Polycaik’s no-code videogame
          development software.
        </>,
        { fontSize: "1.5rem" },
      )}
      <PkCommonArrow color={"white"} />
      {getLayoutView(
        <>
          APPLY <span style={{ fontFamily: "Lato-Bold" }}> TODAY </span>
        </>,
        [
          getLayoutText(
            <>
              Submit your application to join our{" "}<span>{new Date().getFullYear()}</span>{" "}cohort of game creators.
              It’s time to own your story. Apply now to build it with Polycaik.
            </>,
          ),
        ],
        [12],
        {
          p: `8rem 10%`,
          backgroundColor: (theme) => theme.palette.grey[800],
        },
      )}
      <PkCommonArrow color={(theme) => theme.palette.grey[800]} />
      {Application()}
    </Box>
  );
}
